// Default client fetch path for direct local Hono development. Deployed
// environments override this to the versioned static asset path.
export const I18N_TRANSLATIONS_BASE_PATH = '/i18n/resources/components/{ns}/{lng}.json';
export const I18N_LANGUAGE_AVAILABLE = ['nl', 'fr', 'en', 'de', 'nl_nl'];
export const I18N_LANGUAGE_FALLBACK = 'nl';
export const I18N_NAMESPACES = {
    general: 'general',
    product: 'product',
    store: 'store',
    form: 'form',
    dpe: 'dpe',
    checkout: 'checkout',
    buy: 'buy',
    account: 'account',
    navigation: 'navigation',
    rental: 'rental',
    seo: 'seo',
    brand: 'brand',
};
export const I18N_NAMESPACE_FALLBACK = 'general';
